var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgP4RMapView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5,9 L16,5 L27,9 L39,5 V31 L28,35 L17,31 L5,35 Z",
    fill: "#7C1CFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16,5 V31 L17,31 L17,6 Z M27,9 V35 L28,35 L28,9 Z",
    fill: "#00D4FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15,23 C18,18 22,16 27,16 C32,16 36,18 40,23 C36,28 32,30 27,30 C22,30 18,28 15,23 Z",
    fill: "#FFFFFF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27,19 A4,4 0,1 0,27,27 A4,4 0,1 0,27,19",
    fill: "#0D0D12"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27,21 A2,2 0,1 0,27,25 A2,2 0,1 0,27,21",
    fill: "#FFD000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgP4RMapView);
export default __webpack_public_path__ + "static/media/p4r_map_view.6194751459c7f83fb11798ad8cf6a94f.svg";
export { ForwardRef as ReactComponent };